import React from 'react';
import {View} from 'react-native';
import moment from 'moment';

import Text from '../../elements/Text';
import CachedImage from '../../elements/CachedImage';

import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';
import {tID} from '../../../utils/TestIdHelper';

const ResourceCard = ({item}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  return (
    <View testID={tID('ResourceCard-View-Main')} style={styles.container}>
      <CachedImage source={item.heroImage} style={styles.image} />
      <View style={styles.content}>
        <Text
          testID={tID('ResourceCard-Text-Title')}
          numberOfLines={2}
          variation="Body1SemiBold"
          color={colors.textPrimary}>
          {item.title}
        </Text>
        <Text
          testID={tID('ResourceCard-Text-AuthorName')}
          numberOfLines={1}
          variation="Text2SemiBold"
          color={colors.textMuted}
          topMargin={14}>
          {item.articleAuthorLink.length > 0
            ? item.articleAuthorLink[0].articleAuthor.name
            : ''}
        </Text>
        <Text
          testID={tID('ResourceCard-Text-Published')}
          numberOfLines={1}
          variation="Text2SemiBold"
          color={colors.textMuted}
          topMargin={8}>
          {moment(item.published).fromNow()}
        </Text>
        <View style={styles.tagContainer}>
          <Text
            testID={tID('ResourceCard-Text-ArticleCategory')}
            numberOfLines={1}
            variation="Text1SemiBold"
            color={colors.link}>
            {item.articleCategoryLink.length > 0
              ? item.articleCategoryLink[0].articleCategory.name
              : ''}
          </Text>
        </View>
      </View>
    </View>
  );
};

export default ResourceCard;
